import React from 'react';
import '../styles/login.scss';
import u from '../utilities/Utilities';
import store from 'store';
import {Button} from '../components-static/Input';
import PublicPageLayout from '../components-app/PublicPageLayout';
import Colors from '../data/Colors';
import {Step} from '../components-static/Common';
import {Box,TextButton} from '../components-static/Input';
import moment from 'moment';
import sha from 'sha1';

export default class LoginPage extends React.Component{

    state={
        error:"",
        step:"Login",
        email:"",
        loading:false,
    };

    componentDidMount=(e)=>{
        const tempUser = store.get("tempUser");

        if(!tempUser){
            const auth = store.get("auth");
            if(auth){
                u.post({
                    url:"/api/validate-token",
                    data:{},
                    success:(callback)=>{
                        for(var key in callback){
                            store.set(key,callback[key]);
                        }
                        store.set("tokenTime",moment().format("YYYY-MM-DD"));

                        if(this.redirect){
                            window.location=this.redirect;
                        }
                        else{
                            window.location=(callback.favorite) ? callback.favorite : "/dashboard";
                        }
                    },
                    error:(error,status)=>{
                        u.logout();
                    }
                });
            }
        }

        const email = u.getUserEmail();

        if(typeof username != "undefined"){
            this.setState({email:email});
        }

        this.setState({instantiated:true});
    }

    onLogin=()=>{
        if(this.state.loading){
            return 0;
        }

        const email = this.refs['email'].validate();
        if(!email.valid){
            this.setState({error:email.value});
            return 0;
        }

        const password=this.refs['password'].validate();
        if(!password.valid){
            this.setState({error:password.value});
            return 0;
        }

        this.setState({loading:true,error:""});

        u.post({
           url:"/noauth/login",
           data:{
                email:email.value,
                password:sha(password.value)
           },
           success:(callback)=>{
               for(var key in callback){
                   store.set(key,callback[key]);
               }
               store.set("tokenTime",moment().format("YYYY-MM-DD"));
               store.remove("dashboard-action");
               store.remove("dashboard-action-label");
               store.set("tempUser",false);
               store.set("auth",moment().format("YYYY-MM-DDTHH:mm:ss"));

               const redirect = store.get("redirect");
               if(redirect){
                   store.remove("redirect");
                   window.location=redirect;
               }
               else{
                   window.location=(callback.favorite) ? callback.favorite : "/dashboard";
               }
           },
           error:(error)=>{
               this.refs['password'].clear();
               this.setState({error:error,loading:false});
           }
       });
    }

    onResetPassword=()=>{
        if(this.state.loading){
            return 0;
        }

        const email = this.refs['resetemail'].validate();
        if(!email.valid){
            this.setState({error:email.value});
            return 0;
        }

        const pass = this.refs['resetpass'].validate();
        if(!pass.valid){
            this.setState({error:pass.value});
            return 0;
        }

        const conf = this.refs['resetconf'].validate();
        if(!conf.valid){
            this.setState({error:conf.value});
            return 0;
        }

        if(pass.value != conf.value){
            this.setState({error:"Passwords do not match"});
            return 0;
        }

        this.setState({loading:true,error:""});
        u.post({
            url:"/noauth/reset-password",
            data:{
                email:email.value,
                password:sha(pass.value),
            },
            success:(callback)=>{
                this.refs['resetemail'].clear();
                this.refs['resetpass'].clear();
                this.refs['resetconf'].clear();
                this.setState({error:"An email verification has been sent to confirm this change",loading:false});
            },
            error:(error,status)=>{
                this.setState({error:error,loading:false});
            }
        });
    }

    onToggleReset=()=>{
        if(this.state.loading){
            return 0;
        }
        this.setState({step:(this.state.step == "Login") ? "Reset Password" : "Login", error:""});
    }

    render(){
        
        return(
            <PublicPageLayout url="/login" title="Login">
                <div style={{position:"relative",textAlign:"center"}}>
                    <div className="login-container">
                        <div className="login-message-container">
                            <h2 className="login-message">{(this.state.step == "Login") ? "Welcome Back" : "Reset Password" }</h2>
                        </div>

                        <div className="page-error">{this.state.error}</div>

                        <Step active={(this.state.step == "Login")}>
                            <form className="login-form" onSubmit={this.onLogin}>
                                <div className="input-item">
                                    <div className="input-label">Email:</div>
                                    <Box ref="email" label="Email" field="email" type="text" values={{enabled:!this.state.loading}} type="email" rules={{required:true}}/>
                                </div>
                                <div className="input-item">
                                    <div className="input-label">Password:</div>
                                    <Box ref="password" label="password" type="password" values={{enabled:!this.state.loading}} rules={{required:true}}/>
                                </div>
                                <div className="input-button">
                                    <div className="half">
                                        <TextButton onClick={this.onToggleReset} style={{margin:0}}>Forgot My Password</TextButton>
                                    </div>
                                    <div className="half short">
                                        <Button onClick={this.onLogin} type="large">Login</Button>
                                    </div>
                                </div>
                            </form>
                        </Step>
                        <Step active={(this.state.step == "Reset Password")}>
                            <form className="login-form" onSubmit={this.onResetPassword}>
                                <div className="input-item">
                                    <div className="input-label">Email:</div>
                                    <Box ref="resetemail" label="Email" field="email" type="email" values={{enabled:!this.state.loading}} rules={{required:true}}/>
                                </div>
                                <div className="input-item">
                                    <div className="input-label">Password:</div>
                                    <Box ref="resetpass" label="Password" field="new-password" type="password" values={{enabled:!this.state.loading}} rules={{required:true}}/>
                                </div>
                                <div className="input-item">
                                    <div className="input-label">Confirm Password:</div>
                                    <Box ref="resetconf" label="Password Confirm" field="confirm-password" type="password" values={{enabled:!this.state.loading}} rules={{required:true}}/>
                                </div>
                                <div className="input-button">
                                    <div className="half">
                                        <TextButton onClick={this.onToggleReset} style={{margin:0}}>Login Now</TextButton>
                                    </div>
                                    <div className="half short">
                                        <Button onClick={this.onResetPassword} type="large">Reset</Button>
                                    </div>
                                </div>
                            </form>
                        </Step>  
                    </div>

                    <div className="disclaimer">
                        <div className="disclaimer-text">
                            This web application is intended for users with administrator access. If you are not an administrator please download the app from the respective stores
                        </div>
                        <div className="disclaimer-buttons">
                            <img src="/images/app/appstore-badge.png" className="badge" onClick={()=>{u.onAppStore()}}/>
                            <img src="/images/app/play-badge.png" className="badge" onClick={()=>{u.onPlayStore()}}/>
                        </div>
                    </div>

                </div>
            </PublicPageLayout>
        );
    }
};